//Examples:
// import { showAlert } from './modules/example.js';
// jQuery(function () {
//     showAlert();
// });

// Entry point for all JS. Only need to name functions that are used in main.js.
// import { initUI } from './modules/ui.js';
// import { initMap } from './modules/map.js';
// import { initForms } from './modules/forms.js';
// jQuery(function ($) {
//   initUI();
//   initMap();
//   initForms();
// });
const $ = window.jQuery;

import { init } from './modules/init.js';
import {log} from './modules/utils.js';

// import { initFalconModal } from './modules/falconModal.js';
import { initFenixModal } from './modules/fenixModal.js';
import { initPostMediaGalleries } from './modules/postMediaGallery.js';
import { initUserMediaUploads } from './modules/user-media-uploads.js';

import { initMapPage } from './modules/mapPage.js';
import { initPlannerPage, initPlannerUI } from './modules/plannerPage.js';
import { initDirectoryPage } from './modules/directoryPages.js';
import { initManagePage } from './modules/managePage.js';
import { initFavoritesPage } from './modules/favoritesPage.js';

import { initHulk } from './modules/hulk.js';
import { initCommon } from './modules/common.js';

$(function () {
    console.log("jQuery loaded!");
    
    //Init App
    init();
    const waldo = window.ironman.waldo;

    //Turn on debug mode
    window.ironman.debug = true;

    //Init specific page.
    if( waldo === 'map') {
        // Initialize map page
        initMapPage();
        log('Map page initialized');
    } else if (waldo === 'planner') {
        // Initialize planner page here if needed
        initPlannerPage();
        log('Planner page initialized');
    } else if (waldo === 'planner-create') {
        // Initialize planner page here if needed
        initPlannerUI();
        log('Planner create page initialized');
    } else if (waldo === 'place') {
        initDirectoryPage();
        log('Place page initialized');
    } else if (waldo === 'camino') {
        initDirectoryPage();
        log('Camino page initialized');
    } else if (waldo === 'listing') {
        initDirectoryPage();
        log('Listing page initialized');
    } else if (waldo === 'directory-home') {
        initDirectoryPage();
        log('Directory home page initialized');
    } else if (waldo === 'edit-post') {
        // Allow for user media uploads
        initUserMediaUploads();
        log('Edit post page initialized');
    } else if (waldo === 'manage') {
        initManagePage();
        log('Manage page initialized');
    } else if (waldo === 'favorites') {
        initFavoritesPage();
        log('Favorites page initialized');
    }

    // Initialize Common Functions
    initCommon();

    // Initialize Falcon/Fenix Modal if it exists
    // initFalconModal();
    initFenixModal();

    // Initialize Post Media Galleries if they exist
    initPostMediaGalleries();

    // Initialize Hulk if in the body class
    if(document.body.classList.contains('use_hulk')) {
        initHulk();
        log('Hulk initialized');
    }

});
